<template>
  <div>
    <el-card>
      <div class="tui-headerRight">
        <div
          class="tui-qiehuan"
          @click="checkLookSelf()"
          v-if="!userInfo.UserIdentity.includes('1')"
        >
          <img
            src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-5/2022-5-19/20220519160734_5567.png"
            mode=""
          />
          <div class="">
            {{ isOnlyLookSelf ? "全员" : "班级" }}
          </div>
        </div>
        <div
          class="tui-qiehuan"
          @click="onClickDownload()"
          style="margin-left: 20px"
        >
          <div class="">批量下载</div>
        </div>
      </div>
      <div class="comment-list" v-if="List.length != 0">
        <!-- 评论列表-start -->
        <div class="comment-box" v-for="(item, index) in List" :key="index">
          <div class="comment-box-item">
            <div class="flex" style="padding-bottom: 20px">
              <div>
                <el-image
                  class="avatar"
                  :src="
                    item.AvatarUrl
                      ? item.AvatarUrl
                      : 'http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-12/2022-12-6/20221206114603_8671.png'
                  "
                  fit="contain"
                ></el-image>
              </div>
              <div class="comment-main">
                <!-- 父评论体-start -->
                <div class="comment-main-top">
                  <div class="nick-name-box">
                    <div class="nick-name">{{ item.Name }}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="nick-time">
              {{ item.CreateTime }}
            </div>
            <div
              class="flex-items"
              style="padding: 10px 0; font-size: 24px; font-family: AliBaFont"
            >
              评分：
              <el-rate v-model="item.Score" disabled> </el-rate>
            </div>
            <div class="comment-main-content">
              {{
                item.Content.length > 60
                  ? item.Content.slice(0, 59)
                  : item.Content
              }}
              <span v-if="item.Content.length > 60">
                {{ item.hasShowMore ? item.Content.slice(59) : "..." }}
                <span class="foot-btn" @click="showMore(item.Id)">
                  {{ item.hasShowMore ? "收起" : "展开" }}
                </span>
              </span>
            </div>
            <div class="imageList" style="padding: 10px 0 0 0">
              <!-- 图文 -->
              <template v-if="item.RecordType == 2">
                <div
                  class="imageItem"
                  v-for="(itemImg, keys) in getJson(item.Image)"
                  :key="keys"
                >
                  <el-image
                    style="width: 200px; height: 200px"
                    :src="itemImg"
                    :preview-src-list="getJson(item.Image)"
                    fit="contain"
                  ></el-image>
                </div>
              </template>
              <!-- 视频 -->
              <template v-if="item.RecordType == 3">
                <div class="video">
                  <video
                    :src="item.Video"
                    controls
                    style="width: 400px; height: 400px"
                  ></video>
                </div>
              </template>
            </div>
            <div
              class="flex-between"
              :style="{
                borderBottom:
                  index == List.length - 1 ? '' : '1px solid #EEEEEE',
              }"
              style="
                padding: 30px 0;
                font-family: AliBaFont;
                border-bottom: 1px solid #eeeeee;
              "
            >
              <div class="flex-items">
                <img
                  style="width: 32px; height: 32px"
                  v-if="!item.IsCollection"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-12/2022-12-9/20221209140609_6444.png"
                  alt=""
                />
                <img
                  style="width: 32px; height: 32px"
                  v-if="item.IsCollection"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-12/2022-12-9/20221209140623_2253.png"
                  alt=""
                />
                <div class="" style="padding-left: 10px">
                  收藏
                  <span>{{ item.CollectionNum }}</span>
                </div>
              </div>
              <div class="flex-items">
                <i class="el-icon-chat-round" style="font-size: 30px"></i>
                <div class="" style="padding-left: 10px">
                  评论
                  <span>{{ item.CommentNum }}</span>
                </div>
              </div>
              <div class="flex-items">
                <img
                  style="width: 32px; height: 32px"
                  v-if="!item.IsFavourite"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-12/2022-12-9/20221209140357_0246.png"
                  alt=""
                />
                <img
                  style="width: 32px; height: 32px"
                  v-if="item.IsFavourite"
                  src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/2022-12/2022-12-9/20221209140430_4365.png"
                  alt=""
                />
                <div class="" style="padding-left: 10px">
                  点赞
                  <span>{{ item.FabulousNum }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination
          @size-change="handleSizeChangeMyMake"
          @current-change="handleCurrentChangeMyMake"
          :current-page="PageIndex"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="text-align: center; padding: 20px 0 0 0"
        >
        </el-pagination>
      </div>
      <el-empty description="暂无评价记录" v-if="List.length == 0"></el-empty>
    </el-card>
    <!-- 批量下载 -->
    <el-dialog title="批量下载" :visible.sync="dialogVisible" width="70%">
      <div>
        <el-row :gutter="20">
          <div class="flex-end">
            全选：
            <el-switch
              v-model="isAll"
              @change="onChangeAll"
              active-color="#32c5ff"
            >
            </el-switch>
          </div>
          <el-col
            :span="6"
            v-for="(item, index) in imgList"
            :key="index"
            style="margin-bottom: 30px"
          >
            <div class="grid-content">
              <el-image
                v-if="getImg(item)"
                style="width: 3.75rem; height: 3.75rem"
                :src="item + '?x-oss-process=style/thumbnail'"
                :preview-src-list="srcList"
                @click="vbs(item)"
                fit="cover"
              ></el-image>
              <video
                :src="item"
                style="width: 3.75rem; height: 3.75rem"
                v-if="!getImg(item)"
              ></video>
              <!-- 多选 -->
              <div
                class="company-item"
                :class="isActiveFn(item) ? 'active' : ''"
                @click.stop="checkFn(item)"
              ></div>
            </div>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="onDownload">下 载</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { GetRecordInfoByPage, GetRecordDownImgList } from "../../api/api";
import JSZip from "jszip";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      userInfo: {},
      List: [],
      CircleType: 1, //0  默认不晒选  1班级
      List: [],
      changePlay: false,
      videoElement: [], // 创建一个数组
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      isOnlyLookSelf: false, //是否只看自己
      dialogVisible: false,
      isChange: [],
      imgList: [],
      dataObj: {
        region: "oss-cn-shanghai", //我的存储是北京，可根据具体配置自行修改
        accessKeyId: "LTAI5tFV2gKH9MHbHip3UUFV",
        accessKeySecret: "bew7cr5TthXrrkQkHauZG10xuqKW8z",
        bucket: "mushroomisand",
      }, //存签名信息
      baseAli: "http://mushroomisand.oss-cn-shanghai.aliyuncs.com", //我的存储是北京，可根据具体配置自行修改
      isAll: false,
      srcList: [],
    };
  },
  mounted() {},
  created() {
    this.userInfo = JSON.parse(window.localStorage.getItem("user"));
    if (this.userInfo.UserIdentity.includes("1")) {
      this.CircleType = 0;
      this.isOnlyLookSelf = true;
    }
    this.GetRecordInfoByPage();
  },
  methods: {
    vbs(val) {
      this.srcList = [];
      this.srcList.push(val);
    },
    checkFn(item) {
      console.log(item);
      let index = this.isChange.findIndex((ele) => {
        return ele === item;
      });
      if (index != -1) {
        this.isChange.splice(index, 1); //取消选中
      } else {
        this.isChange.push(item); //选中
      }
    },
    isActiveFn(item) {
      //判断元素是否选中
      //index如果不是-1，那就说明是被选中的
      let index = this.isChange.findIndex((ele) => {
        return ele === item;
      });
      if (index != -1) {
        return true;
      } else {
        return false;
      }
    },
    onChangeAll(e) {
      console.log(e);
      if (e) {
        this.isChange = JSON.parse(JSON.stringify(this.imgList)); //JSON.parse(JSON.stringify())解决引用
      } else {
        let parseChecked = [];
        this.imgList.forEach((item) => {
          //判断原数组list的每一项，判断他们是否被选中，没被选中就push到这个parseChecked
          let index = this.isChange.findIndex((ele) => {
            return ele === item;
          });
          if (index == -1) {
            parseChecked.push(item);
          }
        });
        //把所有的没被选中的parseChecked给isChange
        this.isChange = parseChecked;
      }
    },
    downloadFile(url) {
      const iframe = document.createElement("iframe");
      iframe.style.display = "none"; // 防止影响页面
      iframe.style.height = 0; // 防止影响页面
      iframe.src = url;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    // 图片视频下载
    onDownload() {
      if (this.isChange.length != 0) {
        // this.isChange.forEach((item) => {
        //   this.downloadFile(item);
        // });
        var blogTitle = `评价批量下载集合${Date.now()}`; // 下载后压缩包的命名
        var zip = new JSZip();
        var promises = [];
        let cache = {};
        let arrImg = [];
        for (let i = 0; i < this.isChange.length; i++) {
          let tempdate = this.isChange[i];

          const index = tempdate.lastIndexOf("/");
          let name = tempdate.substring(index + 1, tempdate.length);
          if (this.getImg(this.isChange[i])) {
            arrImg.push({
              path: tempdate + "?x-oss-process=style/imgset", // 文件链接
              name: name, // 文件名称
            });
          } else {
            arrImg.push({
              path: tempdate,
              name: name, // 文件名称
            });
          }
        }
        console.log(arrImg, "arrImg");

        for (let item of arrImg) {
          // item.path为文件链接地址
          const promise = this.getImgArrayBuffer(item.path).then((data) => {
            console.log(data, "dadadadada");

            // 下载文件, 并存成ArrayBuffer对象(blob)
            zip.file(item.name, data, { binary: true }); // 逐个添加文件
            cache[item.name] = data;
          });
          promises.push(promise);
        }
        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: "blob" }).then((content) => {
              // 生成二进制流
              FileSaver.saveAs(content, blogTitle); // 利用file-saver保存文件  自定义文件名
            });
          })
          .catch((res) => {
            alert("文件压缩失败");
          });
      } else {
        this.$message({
          type: "error",
          message: "请选择批量下载的文件",
        });
      }
    },
    //文件以流的形式获取（参数url为文件链接地址）
    getImgArrayBuffer(url) {
      return new Promise((resolve, reject) => {
        //通过请求获取文件blob格式
        let xmlhttp = new XMLHttpRequest();
        xmlhttp.open("GET", url, true);
        xmlhttp.responseType = "blob";
        xmlhttp.onload = function () {
          if (this.status == 200) {
            resolve(this.response);
          } else {
            reject(this.status);
          }
        };
        xmlhttp.send();
      });
    },
    //下载文件 　　js模拟点击a标签进行下载
    saveAs(blob, filename) {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;
      link.click();
    },
    getImg(filePath) {
      //获取最后一个.的位置
      var index = filePath.lastIndexOf(".");
      //获取后缀
      var ext = filePath.substr(index + 1);
      //判断是否是图片
      return this.isAssetTypeAnImage(ext);
    },
    isAssetTypeAnImage(ext) {
      return (
        [
          "png",
          "jpg",
          "jpeg",
          "bmp",
          "gif",
          "webp",
          "psd",
          "svg",
          "tiff",
        ].indexOf(ext.toLowerCase()) !== -1
      );
    },
    clickBtn(item) {
      // 多选
      if (this.isChange.indexOf(item) == -1) {
        this.isChange.push(item); //选中添加到数组里
      } else {
        // console.log(this.isChange.indexOf(item));
        this.isChange.splice(this.isChange.indexOf(item), 1); //取消选中
      }
    },
    // 批量下载
    async onClickDownload() {
      let res = await GetRecordDownImgList({
        SourceId: this.$route.query.SourceId,
        studentId: 0,
        sysUserId: this.userInfo.uID,
        TeacherId: 0,
        IsTeacher: this.userInfo.UserIdentity.indexOf("1") != -1 ? 0 : 1,
        IsClass: this.CircleType,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.dialogVisible = true;
        this.imgList = res.data.response;
      } else {
        this.imgList = [];
      }
    },
    checkLookSelf() {
      this.isOnlyLookSelf = !this.isOnlyLookSelf;
      if (this.isOnlyLookSelf) {
        this.CircleType = 0;
      } else {
        this.CircleType = 1;
      }
      this.PageIndex = 1;
      this.List = [];

      this.GetRecordInfoByPage();
    },
    handleSizeChangeMyMake(e) {
      this.PageSize = e;
      this.GetRecordInfoByPage();
    },
    //分页
    handleCurrentChangeMyMake(val) {
      this.PageIndex = val;
      this.GetRecordInfoByPage();
    },
    handlePlay(index) {
      const videoElement = this.videoElement;
      if (videoElement && videoElement.length > 0) {
        console.log(123);
        for (let i = 0; i < videoElement.length; i++) {
          if (i === index) {
            this.videoElement[i].play();
          } else {
            this.videoElement[i].pause();
          }
        }
      }
    },
    getJson(val) {
      if (val) {
        return val.split(",");
      }
    },
    async GetRecordInfoByPage() {
      let res = await GetRecordInfoByPage({
        SourceId: this.$route.query.SourceId,
        studentId: 0,
        sysUserId: this.userInfo.uID,
        TeacherId: 0,
        IsTeacher: this.userInfo.UserIdentity.indexOf("1") != -1 ? 0 : 1,
        IsClass: this.CircleType,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: "",
      });
      if (res.data.success) {
        this.List = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.List = [];
        this.total = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-rate__icon {
  font-size: 35px;
}
/deep/.el-rate {
  height: auto;
}
.flex-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px 30px 0;
}
.company-item {
  width: 25px;
  height: 25px;
  background: url(../../assets/duoxuan.png) no-repeat;
  background-size: 100% 100%;
  margin-top: 20px;
  cursor: pointer;
}
.active {
  background: url(../../assets/duoxuan-activite.png) no-repeat;
  background-size: 100% 100%;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.flex-between {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.flex-items {
  display: flex;
  align-items: center;
}
.tui-border {
  flex: 1;
  height: 1px;
  background-color: #efefef;
}

.imageList .imageItem:nth-child(3n + 3) {
  margin-right: 0px;
}

.imageList {
  padding-top: 30px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .imageItem {
    display: inline-template;
    margin-right: 10px;
  }
}

.tui-headerRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 30px 30px 30px 0;
  background-color: #fff;
  box-sizing: border-box;

  .tui-qiehuan {
    padding: 0 20px;
    height: 56px;
    background: #f0fafd;
    border-radius: 32px;
    display: flex;
    align-items: center;
    font-family: AlibaFont;
    cursor: pointer;

    image {
      width: 30px;
      height: 30px;
    }

    div {
      font-size: 24px;
      padding-left: 10px;
      color: #32c5ff;
    }
  }
}

.safe-padding {
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  box-sizing: content-box;
}

.flex-column {
  display: flex;
  align-items: center;
  flex-direction: column;
}

.add-btn {
  font-family: AliBaFont;
}

/deep/.uniui-back {
  color: #333 !important;
}

.tui-bottom {
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: fixed;
  left: 0;
  right: 0;
  left: var(--window-left);
  right: var(--window-right);
  bottom: var(--window-bottom);
  padding: 10px 0;
  border-top: 1px solid #eeeeee;

  .tui-bottomComment {
    width: 488px;
    height: 64px;
    background: #f5f5f5;
    border-radius: 35px;
    color: #cccccc;
    font-size: 32px;
    font-family: AliBaFont;
    display: flex;
    align-items: center;
    padding-left: 30px;
  }
}

.comment-list {
  width: 100%;
  background-color: #fff;

  box-sizing: border-box;
  padding-bottom: 100px;

  .comment-num {
    width: 686px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0 20px 0;
    font-family: AliBaFontBood;
    font-size: 28px;
  }
}

.hb-comment {
  padding: 10px;
}

.top-read {
  font-size: 28px;
  padding-left: 10px;
  font-family: AliBaFont;
  color: #999999;
}

.seg_line_box {
  display: flex;
  height: 5px;
  justify-content: space-between;
  margin: 5px 0;
}

.seg_line {
  width: 45%;
  border-bottom: 1px solid #e1e1e1;
}

.seg_dot {
  width: 8%;
  border-bottom: 5px dotted #dbdbdb;
}

.comment-box {
  width: 686px;
  margin: 0 auto;
  padding: 10px 0;
}

.comment-box-item {
  display: flex;
  flex-direction: column;
}

.comment-main {
  width: 100%;
  padding-left: 20px;
}

.comment-main-top {
  width: 600px;

  display: flex;
  justify-content: space-between;

  .tui-right {
    display: flex;
    align-items: center;

    .detele {
      width: 90px;
      height: 48px;
      background: #fff9ed;
      border-radius: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #ffbf4e;
      font-size: 24px;
      font-family: AliBaFont;
      margin-left: 20px;
    }

    .common {
      width: 90px;
      height: 48px;
      background: #f0fafd;
      border-radius: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #32c5ff;
      font-size: 24px;
      font-family: AliBaFont;
    }
  }
}

.sub-comment-main-top {
  padding-top: 6px;
  display: flex;
  justify-content: space-between;
}

.avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.nick-name-box {
  display: flex;
  flex-direction: column;
}

.comLogo {
  margin-right: 18px;
  font-size: 22px;
  border-radius: 10px;
  font-family: AliBaFont;
  padding: 5px 15px;
  color: #ffffff;
}

.com1 {
  background-color: #d218b1;
}

.com2 {
  background-color: #f19c0b;
}

.com3 {
  background-color: #c8da85;
}

.com4 {
  background-color: #bfd0da;
}

.nick-name {
  color: #333;
  font-size: 28px;
  font-family: AliBaFont;
}

.nick-time {
  font-size: 22px;
  color: #999;
  font-family: AliBaFont;
}

.isLike {
  font-size: 28px;
  font-family: AliBaFont;
  padding-right: 10px;
  color: #32c5ff;
}

.notLike {
  font-size: 28px;
  font-family: AliBaFont;
  padding-right: 10px;
  color: #999999;
}

.comment-main-content {
  // background-color: #EAEAEA;
  padding: 20px 10px 30px 0;
  font-size: 28px;
  color: #333;
  font-family: AliBaFont;
}

.comment-main-foot {
  display: flex;
  font-family: AliBaFont;
  font-size: 22px;
}

.replayTag {
  color: #909399;
  margin-bottom: 5px;
  border: 1px solid #c8c9cc;
  background-color: #f4f4f5;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-family: AliBaFont;
  padding: 5px 10px;
}

.replyTagClose {
  font-size: 20px;
  font-family: AliBaFont;
  line-height: 12px;
  padding: 0 0 2px 5px;
}

.foot-btn {
  padding-left: 10px;
  color: #32c5ff;
}

.comment-sub-box {
  width: 689px;
  box-sizing: border-box;
  background: #fbfbfb;
  border-radius: 10px;
  padding: 20px 0;
}

.comment-sub-item {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin-bottom: 20px;
}

.comment-none {
  padding: 20px;
  width: 100%;
  span-align: center;
  color: #999999;
}

.comment-submit-box {
  position: fixed;
  display: flex;
  align-items: flex-end;
  z-index: 9900;
  left: 0;
  // top: var(--window-top);
  bottom: 0;
  width: 100%;

  div {
    width: 580px;
    height: 80px;
    background-color: rgb(50, 197, 255);
    color: #fff;
    font-size: 28px;
    font-family: AliBaFont;
    border-radius: 30px;
    margin: 30px auto;
  }
}

.comment-add {
  position: fixed;
  background-color: #ffffff;
  width: 100%;
  padding: 5px;
  border: 1px solid #ddd;
  transition: 0.3s;
  -webkit-transition: 0.3s;
}

.btn-click {
  color: #007aff;
  font-size: 28px;
  padding: 10px;
  font-family: AliBaFont;
}

.cancel {
  color: #606266;
}

.spanarea {
  height: 100px;
  padding: 16px;
  width: 100%;
}

.comment-submit {
  padding: 5px 20px 0 20px;
  border-bottom: 1px dashed #ddd;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.tui-content {
  width: 100%;
  min-height: 500px;
  background-color: #fff;
  padding: 40px;
  box-sizing: border-box;
}

.tui-box-item {
  width: 100%;

  background: #ffffff;
  box-shadow: 3px 4px 8px 1px rgba(102, 102, 102, 0.07);

  margin: 0 auto;
  margin-bottom: 20px;
  padding: 0 40px 0 40px;
  box-sizing: border-box;

  .tui-title {
    font-size: 32px;
    font-family: AliBaFont;
    font-family: AliBaFontBood;
    color: #333333;
  }

  .tui-images {
    width: 100%;
    height: 226px;
    border-radius: 20px;
    margin: 0 auto;
    padding-top: 20px;
  }
}
</style>